

<div class="PolicyContainer">
    <header>
      <h1>Disclaimer</h1>
    </header>
  
    <section class="policy-content">
      <p>This document outlines the disclaimers applicable to accessing and using the {{Company_Name}} (“Platform”), including the Website {{Website_URL}}, the Mobile Application, and any other subdomains or platforms owned, developed, managed, or operated by {{Company_Name}} and/or its affiliates. {{Company_Name}} is incorporated under the laws of India and registered under the Companies Act, 2013. The terms "You", "Your", and "User" refer to individuals availing themselves of the Services and Products through the Platform.</p>
  
      <p>This document constitutes an electronic record under the Information Technology Act, 2000, and no physical or digital signatures are required. By using the Platform, You accept the terms and conditions and agree to use the Services in accordance with the rules set by {{Company_Name}}.</p>
  
      
  
      <h2>Liability of Our Services</h2>
      <p>{{Company_Name}}, its directors, employees, agents, partners, licensors, and affiliates shall not be liable for any direct, indirect, incidental, consequential, punitive, or exemplary damages, including but not limited to investment losses, lost opportunities, lost revenue, or profits, regardless of how they arise.</p>
  
      <p>Liability shall not exceed ₹500 or the amount prescribed by regulatory guidelines, whichever is lower. You acknowledge that the limitations of liability are reasonable and necessary for {{Company_Name}} to provide its Services.</p>
  
      
  
      <h2>User Data</h2>
      <p>The Platform may collect and analyze data on your usage to provide personalized features, recommendations, and communications. Any investment decisions are solely at your discretion. Viewing information on the Platform does not constitute investment advice. You should seek professional, legal, tax, or financial advice before making decisions regarding your investments.</p>
  
      
  
      <h2>Contingency Process</h2>
      <p>The Platform’s functionality may rely on third-party systems, which may experience errors or downtime. {{Company_Name}} reserves the right to suspend services if security or functionality is compromised.</p>
  
      
  
      <h2>Offer Document Disclaimer</h2>
      <p>Investments in Mutual Funds are subject to market risks. Read scheme-related documents carefully. Past performance does not guarantee future returns.</p>
  
      <p>{{Company_Name}} acts as an intermediary to submit orders to the relevant AMC or collection agent and does not provide legal, tax, or accounting advice. Users should verify all information and seek professional advice before investing.</p>
  
      <p>The Platform makes no warranties regarding product availability, accuracy, or future performance. {{Company_Name}} and its service providers are not liable for events beyond their control, including natural disasters, system failures, strikes, or regulatory changes.</p>
  
      
  
      <h2>Onus of Providing User Information</h2>
      <p>All personal and financial information provided by users must be accurate and complete. {{Company_Name}} is not responsible for rejections by AMCs, RTAs, or KRA due to incorrect or incomplete information. Users are responsible for:</p>
      <ul>
        <li>Mutual Fund Details & Returns Graphs – Information is obtained from third-party vendors. Actual returns may differ.</li>
        <li>AMC Data & Insta Redemptions – Platform acts as an intermediary. Users should check timelines and limits per SEBI guidelines.</li>
        <li>Performance, Comparison & Riskometer – Data is indicative; users should make independent investment decisions.</li>
        <li>KYC / PAN / Aadhaar / FATCA – Users must provide accurate documentation. Platform is not liable for delays or rejections.</li>
        <li>Bank Account Verification – Users must keep bank details updated; the Platform is not liable for changes post-validation.</li>
        <li>Account Opening Forms & Communication – Platform forwards user information to RTAs/AMCs. Users must provide correct contact details.</li>
        <li>Nominations – Nominees declared on the Platform will be applied across folios; users must verify with AMCs.</li>
      </ul>
  
      
  
      <h2>Portfolio & Value-Added Services</h2>
      <p>Services like portfolio tracking, P&amp;L, capital gains, and statements are provided on a best-effort basis. Users should verify the information before acting on it. Historical returns and holdings are for reference only and may not represent future performance.</p>
  
      
  
      <h2>Payments</h2>
      <p>All transactions are facilitated through third-party payment gateways. Users must use their own verified accounts. {{Company_Name}} is not responsible for:</p>
      <ul>
        <li>Failed or pending transactions.</li>
        <li>Fraudulent transactions.</li>
        <li>Refund delays due to bank or gateway processing timelines.</li>
      </ul>
      <p>Payment methods include UPI, Net Banking, IMPS, NEFT, RTGS, and Mandates. Users are responsible for ensuring successful transactions and compliance with third-party terms.</p>
  
      
  
      <h2>Transactions</h2>
      <ul>
        <li>Financial Transactions – Processed as per business rules and cut-off times; subject to third-party system capabilities.</li>
        <li>Non-Financial Transactions – Requests are sent to RTAs; processing timelines depend on them.</li>
        <li>RTA Coordination – Platform acts as an intermediary; actual execution depends on AMC/RTA systems.</li>
        <li>Settlements – Banks and Payment Gateways handle fund settlement; NAV applicable per AMFI/SEBI guidelines.</li>
      </ul>
      <p>Users understand that using the Platform does not create any direct contractual relationship with {{Company_Name}} beyond acting as an intermediary.</p>
    </section>
  </div>
  